module.exports = __webpack_public_path__ + "img/CM-BS-25-CDJR-Lifestyle.9732751d.jpg";